module.exports = __webpack_public_path__ + "static/media/card_white_shape.391a9c1b.svg";